export default __webpack_public_path__ + "static/logo_amc_gold-6b43866849cfadffe85108605bcf32a3.png";